import { render } from "./chartA.vue?vue&type=template&id=33fa285c"
import script from "./chartA.vue?vue&type=script&lang=ts"
export * from "./chartA.vue?vue&type=script&lang=ts"
script.render = render

export default script